export const getUpgradeButton = (theme)=>({
        base: {
            color: theme.button.upgrade.label,
            backgroundColor: theme.button.upgrade.default,
            backgroundBlendMode: 'lighten, normal',
            boxShadow: '0 1px 0 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.05), 0 4px 6px 0 rgba(255, 255, 255, 0.15) inset',
            border: `1px solid ${theme.button.primary.border}`,
            '&:hover': {
                backgroundColor: theme.button.upgrade.hover
            },
            '&:active, &:focus:not(:focus-visible)': {
                backgroundColor: theme.button.upgrade.hover,
                outline: 'none',
                boxShadow: '0 1px 0 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.05), 0 4px 6px 0 rgba(255, 255, 255, 0.15) inset'
            },
            '&:focus': {
                outline: `2.5px solid ${theme.button.focused.upgrade}`,
                outlineOffset: 4,
                backgroundColor: theme.button.upgrade.default
            }
        },
        active: {},
        isLoading: {},
        disabled: {
            backgroundColor: theme.button.upgrade.disabled,
            border: '1px solid rgba(0, 0, 0, 0.04)',
            color: theme.button.disabled.label,
            cursor: 'not-allowed',
            boxShadow: 'none',
            '&:hover': {
                backgroundColor: 'none'
            },
            '&:active, &:focus:not(:focus-visible)': {
                outline: 'none',
                boxShadow: 'none'
            },
            svg: {
                color: theme.button.ghost.disabled
            }
        }
    });

//# sourceMappingURL=upgrade.js.map